<template>
    <div>
        <div class="container-fluid">
            <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''">
            </div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
            <div class="row">
                <div class="page-loader col-12 p-0" v-if="personality_loader==true">
                    <slick ref="slick" :options="wordslider" class="wordslider">
                        <div><img src="/images/w-wordslider/l_banner1.jpg" alt="Banner" class="w-100" v-if="mobile_view==false">
                            <img src="/images/w-wordslider/m_l_banner1.jpg" alt="Banner" class="w-100" v-else>
                            <div class="banner-content result_loader_main">
                                <img src="/images/result/result_loader1.png" alt="" class="result_loader">
                                <h2 class="font-bold"><span v-html="show_result_heading"></span>  <span class="wordslider-animation">|</span></h2>
                            </div>
                        </div>
                        <div><img src="/images/w-wordslider/l_banner2.jpg" alt="Banner" class="w-100" v-if="mobile_view==false">
                            <img src="/images/w-wordslider/m_l_banner2.jpg" alt="Banner" class="w-100" v-else>
                            <div class="banner-content result_loader_main">
                                <img src="/images/result/result_loader1.png" alt="" class="result_loader">
                                <h2 class="font-bold"><span v-html="show_result_heading"></span>  <span class="wordslider-animation">|</span></h2>
                            </div>
                        </div>
                        <div><img src="/images/w-wordslider/l_banner4.jpg" alt="Banner" class="w-100" v-if="mobile_view==false">
                            <img src="/images/w-wordslider/m_l_banner4.jpg" alt="Banner" class="w-100" v-else>
                            <div class="banner-content result_loader_main">
                                <img src="/images/result/result_loader1.png" alt="" class="result_loader">
                                <h2 class="font-bold"><span v-html="show_result_heading"></span>  <span class="wordslider-animation">|</span></h2>
                            </div>
                        </div>
                        <div><img src="/images/w-wordslider/l_banner5.jpg" alt="Banner" class="w-100" v-if="mobile_view==false">
                            <img src="/images/w-wordslider/m_l_banner5.jpg" alt="Banner" class="w-100" v-else>
                            <div class="banner-content result_loader_main">
                                <img src="/images/result/result_loader1.png" alt="" class="result_loader">
                                <h2 class="font-bold"><span v-html="show_result_heading"></span>  <span class="wordslider-animation">|</span></h2>
                            </div>
                        </div>
                        <div><img src="/images/w-wordslider/l_banner7.jpg" alt="Banner" class="w-100" v-if="mobile_view==false">
                            <img src="/images/w-wordslider/m_l_banner7.jpg" alt="Banner" class="w-100" v-else>
                            <div class="banner-content result_loader_main">
                                <img src="/images/result/result_loader1.png" alt="" class="result_loader">
                                <h2 class="font-bold"><span v-html="show_result_heading"></span>  <span class="wordslider-animation">|</span></h2>
                            </div>
                        </div>
                    </slick>
                </div>
                <div class="page-loader col-12 p-0" v-if="pageloader==true">
                    <slick ref="slick" :options="loaderslider" class="loaderslider">
                        <div><img src="/images/w-wordslider/l_banner1.jpg" alt="Banner" class="w-100" v-if="mobile_view==false">
                            <img src="/images/w-wordslider/m_l_banner1.jpg" alt="Banner" class="w-100" v-else>
                            <div class="banner-content">
                                <h2 class="font-bold"><span v-html="show_personality_heading"></span> <span class="wordslider-animation">|</span></h2>
                                    <button v-if="button_show==true" @click="button_click">Sure, Lets begin!</button>
                            </div>
                        </div>
                        <div><img src="/images/w-wordslider/l_banner2.jpg" alt="Banner" class="w-100" v-if="mobile_view==false">
                            <img src="/images/w-wordslider/m_l_banner2.jpg" alt="Banner" class="w-100" v-else>
                            <div class="banner-content">
                                <h2 class="font-bold"><span v-html="show_personality_heading"></span> <span class="wordslider-animation">|</span></h2>
                                    <button v-if="button_show==true" @click="button_click">Sure, Lets begin!</button>
                            </div>
                        </div>
                        <div><img src="/images/w-wordslider/l_banner4.jpg" alt="Banner" class="w-100" v-if="mobile_view==false">
                            <img src="/images/w-wordslider/m_l_banner4.jpg" alt="Banner" class="w-100" v-else>
                            <div class="banner-content">
                                <h2 class="font-bold"><span v-html="show_personality_heading"></span> <span class="wordslider-animation">|</span></h2>
                                    <button v-if="button_show==true" @click="button_click">Sure, Lets begin!</button>
                            </div>
                        </div>
                        <div><img src="/images/w-wordslider/l_banner5.jpg" alt="Banner" class="w-100" v-if="mobile_view==false">
                            <img src="/images/w-wordslider/m_l_banner5.jpg" alt="Banner" class="w-100" v-else>
                            <div class="banner-content">
                                <h2 class="font-bold"><span v-html="show_personality_heading"></span> <span class="wordslider-animation">|</span></h2>
                                    <button v-if="button_show==true" @click="button_click">Sure, Lets begin!</button>
                            </div>
                        </div>
                        <div><img src="/images/w-wordslider/l_banner7.jpg" alt="Banner" class="w-100" v-if="mobile_view==false">
                            <img src="/images/w-wordslider/m_l_banner7.jpg" alt="Banner" class="w-100" v-else>
                            <div class="banner-content">
                                <h2 class="font-bold"><span v-html="show_personality_heading"></span> <span class="wordslider-animation">|</span></h2>
                                    <button v-if="button_show==true" @click="button_click">Sure, Lets begin!</button>
                                </div>
                        </div>
                     </slick>
                </div>
                <div class="col-12 q-bg" v-if="pageloader==false&&personality_loader==false">
                    <div class="row">
                        <div class="col-md-6" v-if="mobile_view==false">
                            <img src="/images/result/q-banner.jpg" style="max-width: 400px;">
                        </div>
                        <div class="sitemap-inner col-md-6 col-12" v-for="(item,k) in questions" v-if="k==sq">
                            <form>
                                <h4 class="mb-0 font-bold">{{item[0]}}</h4>
                                <div class="form-check w-100" v-for="(items,i) in item[1]">
                                    <input class="form-check-input" v-model="cqa" type="radio" :name="item[0]" :id="i" :value="items.value" required>
                                    <label class="form-check-label" :for="i" :class="{active:cqa==items.value}"><span>{{items.lable}}</span></label>
                                </div>
                                <p><span v-text="sq+1"></span>/<span v-text="questions.length"></span><button type="submit" v-if="sq+1!=questions.length">Next</button>
                                    <button type="submit" v-if="sq+1==questions.length">Submit</button></p>
                            </form>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    @import '../../node_modules/slick-carousel/slick/slick.css';
    </style>
<script>
    import Slick from 'vue-slick';
    import axios from 'axios';
    export default {
        metaInfo() {
            return {
                title: this.meta_title,
                meta: [
                    {
                        name: 'description',
                        content: this.meta_description
                    },
                    {
                        property: 'keywords',
                        content: this.meta_keyword
                    }
                ]
            }
        },
        name:'personality',
        components: {
            Slick
        },
        data() {
            return {
                personality_heading:'“ Hi, I am your Stylist for the day!</br> First, let’s identify your Fashion Personality.</br> Help me know you better.....”',
                show_personality_heading:'',
                result_heading:'“Interesting,</br> your Fashion Personality seems to be...',
                show_result_heading:'',
                personality_loader:false,
                pageloader:true,
                button_show:false,
                cqa:'',
                sq:0,
                meta_title: '',
                meta_description: '',
                meta_keyword: '',
                questions: [],
                sens_q:'',
                personality:'',
                mobile_view:false,
                slickOptions: {
                    centerMode: true,
                    centerPadding: '31%',
                    slidesToShow: 1,
                    responsive: [
                        {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: '28%',
                            slidesToShow: 1
                        }
                        },
                        {
                        breakpoint: 480,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: '28%',
                            slidesToShow: 1
                        }
                        }
                    ]
            },
            loaderslider: {
                slidesToShow:1,
                arrows: false,
                dots: false,
                fade: true,
                infinite: true,
                speed: 500,
                autoplay: true,
                pauseOnFocus: false,
                pauseOnHover: false,
                pauseOnDotsHover: false,
                autoplaySpeed: 1000,
            },
            wordslider: {
                slidesToShow:1,
                arrows: false,
                dots: false,
                fade: true,
                infinite: true,
                speed: 500,
                autoplay: true,
                pauseOnFocus: false,
                pauseOnHover: false,
                pauseOnDotsHover: false,
                autoplaySpeed: 1500,
            },
            };
        },
        methods: {
            button_click(){
                this.pageloader=false;
                this.personality_loader=false;
            }
        },
        beforeMount() {
            axios.get(this.$root.api_url + `/pim/pimresponse.php?service=personality_questions&store=1`)
            .then(response => {
                var result = Object.entries(response.data.result.personality);
                this.questions = result;
                setTimeout(() => { window.scrollTo(0, 0);this.pageloader=false; }, 9500);
            })
        },
        watch: {
            cqa: {
                handler: function () {
                    if(this.sq+1!=this.questions.length)
                {
                    this.sq = this.sq+1;
                    this.sens_q+=this.cqa+',';
                }
                else
                {
                    this.personality_loader = true;
                    this.sens_q+=this.cqa;
                    axios.get(this.$root.api_url + `/pim/pimresponse.php`, {
                        params: {
                            service: 'personality_score',
                            answers:this.sens_q,
                            store: this.$root.store,
                        }
                    })
                    .then(response => {
                        this.personality = response.data.result.personality;
                        this.$root.page_loader = false;
                        this.sq = 0;
                        this.sens_q='';
                        let h = 0;
                        setInterval(()=> {
                            this.result_heading.length;
                            this.show_result_heading = this.show_result_heading+this.result_heading.charAt(h);
                            h = h+1
                        }, 35);
                        setTimeout(() => { 
                            window.scrollTo(0, 0);this.personality_loader=false;
                            if(response.data.result.personality=='Trendsetter')
                            {
                                if(this.$route.query.sort_code&&this.$route.query.sort_code!=''){
                                    this.$router.push(`/trendsetter.html?sort_code=${this.$route.query.sort_code}`); 
                                }
                                else
                                {
                                    this.$router.push(`/trendsetter.html`);
                                }
                            }
                            if(response.data.result.personality=='Every day Icon')
                            {
                                if(this.$route.query.sort_code&&this.$route.query.sort_code!=''){
                                   this.$router.push(`/everyday.html?sort_code=${this.$route.query.sort_code}`); 
                                }
                                else
                                {
                                    this.$router.push(`/everyday.html`);
                                }
                            }
                            if(response.data.result.personality=='Neo-Traditional')
                            { 
                                if(this.$route.query.sort_code&&this.$route.query.sort_code!=''){
                                   this.$router.push(`/nuvo-traditional.html?sort_code=${this.$route.query.sort_code}`); 
                                }
                                else
                                {
                                    this.$router.push(`/nuvo-traditional.html`);
                                }
                            }
                            if(response.data.result.personality=='Minimalist')
                            {
                                if(this.$route.query.sort_code&&this.$route.query.sort_code!=''){
                                   this.$router.push(`/minimalist.html?sort_code=${this.$route.query.sort_code}`); 
                                }
                                else
                                {
                                    this.$router.push(`/minimalist.html`);
                                } 
                            }
                        }, 4000);
                    })
                    .catch(error => {
                        this.$root.page_loader = false;
                    });
                }
                }
            }
        },
        created() {
            this.$root.error_message = '';
            this.$root.success_message = '';
            //if(this.$root.customer_id === null || this.$root.customer_id === ''){
                //this.$router.push('login.html')
            //}
            let i = 0;
            setInterval(()=> {
                this.personality_heading.length;
                this.show_personality_heading = this.show_personality_heading+this.personality_heading.charAt(i);
                i = i+1
                if(this.personality_heading.length==i){
                    this.button_show = true;
                }
            }, 50);
            //for (setTimeout(() => {var i = 0; i < this.personality_heading.length; i++}), 1000){
                //this.show_personality_heading = this.show_personality_heading+this.personality_heading.charAt(i);
            //}
            window.scrollTo(0, 0);
            if (screen.width <= 767) {
                this.mobile_view = true;
            }
            if (this.$root.store === 1) {
                this.meta_title = 'Personality Questions';
                this.meta_description = 'Personality Questions';
                this.meta_keyword = 'Personality Questions';
            }
            else {
                this.meta_title = 'Personality Questions';
                this.meta_description = 'Personality Questions';
                this.meta_keyword = 'Personality Questions';
            }
        }
    }
</script>